var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contentHtml)?_c('div',{staticClass:"message-html",domProps:{"innerHTML":_vm._s(_vm.contentHtml)}}):_c('RichText',{staticStyle:{"white-space":"pre-line","width":"100%"},attrs:{"value":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }